import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	max-width: 100%;
	max-height: 100%;
	min-width: 100%;
	min-height: 100%;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 8px;
	display: grid;
	gap: 1rem;
	grid-template-rows: auto 3.5fr auto auto;
	overflow: hidden;

	-webkit-box-shadow: 0px 0px 11px -6px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 0px 0px 11px -6px rgba(0, 0, 0, 0.75);
	box-shadow: 0px 0px 11px -6px rgba(0, 0, 0, 0.75);
`;

export const like = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	> svg {
		color: ${color.interface.black};
		font-size: 25px;
	}
`;

export const photo = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`;

export const infos = styled.div`
	width: 100%;
	height: 100%;
	gap: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
`;

export const title = styled.div`
	> b {
		font-weight: 900;
		text-align: left;
		font-size: 1.2rem;
		color: ${color.interface.black};
		font-family: nunito-light;
	}
`;

export const brand = styled.div`
	opacity: 0.6;
	> p {
		text-transform: uppercase;
		text-align: left;
		font-size: 1.2rem;
		color: ${color.interface.black};
		font-family: nunito-light;
	}
`;

export const price = styled.p`
	text-align: left;
	font-size: 1.2rem;
	color: ${color.interface.black};
	font-weight: 900;
`;

export const description = styled.div`
	opacity: 0.5;
	> p,
	b,
	h1,
	h2,
	strong {
		all: unset;
	}
`;

export const btnBuy = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.blackMofiq};
	border-radius: 10px;
	padding: 1.5rem 1rem;
	> p {
		text-align: center;
		font-size: 1rem;
		color: ${color.interface.white};
		font-family: nunito-light;
		text-transform: uppercase;
	}
`;

export const starts = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	> svg {
		width: 15px;
		height: 15px;
		color: #ec8267;
	}
`;
